import React from 'react';

export interface CropImageProps {
  imageUrl: string;
  variantColor?: string;
  size: number;
  borderRadius?: number;
}

/** Crop image with a variant color triangle in the top-left corner. */
export const CropImage: React.FC<CropImageProps> = ({
  imageUrl,
  variantColor,
  size,
  borderRadius = 4,
}) => (
  <div
    style={{
      position: 'relative',
      width: size,
      height: size,
      minWidth: size,
      borderRadius,
      overflow: 'hidden',
      border: '1px solid var(--border)',
    }}
  >
    {variantColor && (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          borderLeft: `${Math.round(size * 0.4)}px solid ${variantColor}`,
          borderBottom: `${Math.round(size * 0.4)}px solid transparent`,
          zIndex: 1,
        }}
      />
    )}
    <img
      src={imageUrl}
      alt=""
      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
    />
  </div>
);
